module.exports = __webpack_public_path__ + "static/media/check-yellow.a3a75e34.svg";